const products = [
  { id: 'map52', value: 52, filename: 'MAP', label: 'MAP 52%' },
  { id: 'mes10', value: 40, filename: 'MES10', label: 'MES 10' },
  { id: 'mesZ', value: 40, filename: 'MESZ', label: 'MES Z' },
  { id: 'dap46', value: 46, filename: 'DAP', label: 'DAP 46%' },
  { id: 'other', value: '', filename: 'Other_P', label: 'Other' },
];

export const phosphorus = {
  groups: [25, 50, 75, 100],
  products,
  getProduct: (id, percentage) => {
    const product = products.find((p) => p.id === id);
    return product ? product.label : `Other ${percentage}%`;
  },
};
